<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-25 
-->
<template>
  <div class="speaker-item">
    <div class="header-img" @click="goDetail">
      <img :src="itemDetail.logoUrl | logo_show" />
    </div>
    <div class="name" @click="goDetail">{{itemDetail.name | dealLanguage(itemDetail.enName)}}</div>
    <div class="title" v-html="filter.dealLanguage(itemDetail.companyPosition, itemDetail.enCompanyPosition)"></div>
    <!-- <div class="name" @click="goDetail">{{itemDetail.name}}</div>
    <div class="title" v-if="itemDetail.companyPosition" v-html="itemDetail.companyPosition"></div> -->
  </div>
</template>
<script>
import filter from 'js/filter'
export default {
  inject: ['globalInsertRecords'],
  props: {
    itemDetail: {
      default: () => {},
    },
    sence: {
      default: 1,
    },
  },
  components: {},
  created() {},
  mounted() {},
  data() {
    return {
      filter
    }
  },
  computed: {},
  methods: {
    goDetail() {
      this.globalInsertRecords({
        contentId: this.itemDetail.id,
        contentType: 152,
        viewType: 1,
      })
      this.$router.push({
        name: 'guestInfo',
        params: {
          id: this.itemDetail.id,
        },
      })
      // const { href } = this.$router.resolve({
      //   name: 'guestInfo',
      //   params: {
      //     id: item.id,
      //   }
      // })
      // window.open(href)
      // if(this.scene == 2) {
      // }
    },
  },
}
</script>
<style lang='stylus' scoped>
ellipsisClamp(clamp)
  display -webkit-box
  overflow hidden
  text-overflow ellipsis
  word-break break-all
  -webkit-box-orient vertical
  -webkit-line-clamp clamp
.speaker-item
  width 280px
  background-image url('~pic/speaker-item-bg.png')
  background-repeat no-repeat
  background-size 100% auto
  background-color #FFFFFF
  box-shadow 0px 4px 20px 0px rgba(65, 65, 65, 0.1)
  border-radius 10px
  padding 84px 24px 24px
  .header-img
    width 200px
    height 200px
    margin 0 auto
    border-radius 50%
    cursor pointer
    overflow hidden
    background-color #FFFFFF
    img
      width 100%
      height 100%
      object-fit cover
      transition all 0.3s
    &:hover
      img
        transform scale(1.2)
  .name
    font-size 26px
    color #C8161D
    line-height 36px
    margin-top 20px
    cursor pointer
    transition all 0.3s
    text-align center
    ellipsisClamp(2)
    &:hover
      color #c8161d
  .title
    margin-top 8px
    font-size 14px
    color #333333
    line-height 28px
    min-height 36px
    margin-top 10px
    text-align center
    ellipsisClamp(2)
</style>